import Immutable from 'immutable';
import { createSelector } from 'reselect';

export const selectOpenUgcEditors = createSelector(
  [state => state.getIn(['ui', 'openUgcEditors'], Immutable.Map())],
  editors => editors
);

export default selectOpenUgcEditors;
